const app = Shopify.shop.split(".")[0];

const hostUrl = window.location.host.split(".");
const shopifyDomain =
  hostUrl[0].indexOf("beta-") > -1
    ? window.location.host
    : `.${hostUrl[1]}.${hostUrl[2]}`;
class RegistrationsTrack {
  pvTrack() {
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: "ga4Event",
      event_name: "user_center",
      event_parameters: {
        page_group: "reg_sub_pop",
        position: "",
        button_name: "impression",
      },
    });
  }
  closeTrack({ position, page_group, button_name }) {
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: "ga4Event",
      event_name: "user_center",
      event_parameters: {
        page_group,
        position,
        button_name,
      },
    });
  }
  async registrationsTrack({ action, subscribe, email, deals_type }) {
    const sha256Email = await Shopify.theme.sha256Encoder(email);
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      user_hashed_email: sha256Email, //邮箱加密算法sha256，在注册成功事件上报前推送
    }); //标黄代码须在下方代码前
    window.dataLayer.push({
      event: "ga4Event",
      event_name: "user_center",
      event_parameters: {
        page_group: "reg_sub_pop",
        position: "register",
        button_name: "",
        subscribe_box: subscribe, //订阅勾选框勾选状态取1，没有勾选取0
        action: action, //fail表示注册失败，success表示注册成功
      },
    });
    if (subscribe) {
      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        subscribe_hashed_email: sha256Email, //推订阅的加密邮箱，加密算法sha256-20230726新增
      }); //标黄代码须在下方代码前
      window.dataLayer.push({
        event: "ga4Event",
        event_name: "subscribe",
        event_parameters: {
          page_group: deals_type, //如果没有deals_type，且是底部订阅则传footer，其他情况留空
          position: "reg_sub_pop", //传位置标记，比如首屏传masterbanner、弹窗传pop_up、最后一屏传lastbanner、悬浮框传sticky
        },
      });
      dataLayer.push({
        event: "uaEvent",
        eventCategory: "subscribe",
        eventAction: deals_type, //如果没有deals_type，且是底部订阅则传footer，其他情况留空
        eventLabel: "reg_sub_pop", //传位置标记，比如首屏传masterbanner、弹窗传pop_up、最后一屏传lastbanner、悬浮框传sticky
        nonInteraction: false,
      });
    }
  }
  useCodeTrack() {
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: "ga4Event",
      event_name: "user_center",
      event_parameters: {
        page_group: "reg_sub_pop",
        position: "success",
        button_name: "copy_code",
      },
    });
  }
  loginTrack({ position }) {
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: "ga4Event",
      event_name: "user_center",
      event_parameters: {
        page_group: "login_pop",
        position,
      },
    });
  }
  loginWithThirdTrack({ typeText }) {
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: "ga4Event",
      event_name: "user_center",
      event_parameters: {
        page_group: "login_pop",
        position: "login_" + typeText, // $按钮文案(社媒均小写处理)
      },
    });
  }
  backRegistrationsTrack({ buttonName }) {
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: "ga4Event",
      event_name: "user_center",
      event_parameters: {
        page_group: "login_pop",
        position: "",
        button_name: buttonName, //关闭按钮传close
      },
    });
  }
}

// 订注一体事件
const RegistrationsModal = {
  handleLoadingStatus($el, type) {
    if (type === "loading") {
      $el.find(".js-submit").addClass("hidden");
      $el.find(".js-submit-loading").removeClass("hidden");
      $el.closest("model").css("pointer-events", "none");
    } else {
      $el.find(".js-submit").removeClass("hidden");
      $el.find(".js-submit-loading").addClass("hidden");
      $el.closest("model").css("pointer-events", "auto");
    }
  },
  // 获取passport地址
  getPassportUrl() {
    let passport = "https://";
    if (app.includes("beta")) {
      passport += "beta.";
    }
    if (app.includes("eufy")) {
      passport += "passport.eufy.com";
    }
    return passport;
  },
  // 解析url参数
  parse(search) {
    return (params = search.split("&").reduce((obj, param) => {
      let [key, value] = param.split("=");
      obj[decodeURIComponent(key)] = decodeURIComponent(value);
      return obj;
    }, {}));
  },
  // 获取google授权地址
  getGoogleAuthURL({ location }) {
    const GOOGLE_CLIENT_ID = $(".registrations-third-login").data(
      "google-client-id"
    );
    const googleAuthUrl = $(".registrations-third-login").data(
      "google-auth-url"
    );
    return `https://accounts.google.com/o/oauth2/auth?${Object.entries({
      redirect_uri: encodeURIComponent(googleAuthUrl),
      response_type: "code",
      scope: "email",
      client_id: GOOGLE_CLIENT_ID,
      state: encodeURIComponent(
        JSON.stringify({
          app,
          redirect: location.href,
          ...this.parse(location.search.slice(1)),
          callback: googleAuthUrl,
        })
      ),
      nonce: Date.now(),
    })
      .map(([key, value]) => `${key}=${value}`)
      .join("&")}`;
  },
  // 设置是否弹窗标识
  setFlowUpTag() {
    const _this = this;
    const registrations_pop_up = this.getItemWithExpiry(
      `${Shopify.country}_registrations_pop_up`
    );
    // start_ai_generated
    const $model = $(".registrations-model");
    const email = $model.data("email");
    const showRegistrationsModel = $model.data("show-registrations-model");
    // end_ai_generated
    if (!registrations_pop_up) {
      let timer = setTimeout(() => {
        // 这里渠道弹窗的优先级更高，需要判断是否存在渠道弹窗已经在显示
        const giftCardModal = document.querySelector(".giftcard-pop");
        if (
          !email &&
          showRegistrationsModel &&
          (!giftCardModal || getComputedStyle(giftCardModal).display === "none")
        ) {
          this.setItemWithExpiry(
            `${Shopify.country}_registrations_pop_up`,
            true,
            14 * 24 * 60 * 60 * 1000
          );
          $model.removeClass("hidden");
          _this.registrationsTrackIns.pvTrack();
        }
        clearTimeout(timer);
      }, 5000);
    }
  },
  // 设置cookie
  setItemWithExpiry(key, value, timestamp) {
    const now = new Date();
    const item = {
      value: value,
      expiry: now.getTime() + timestamp, // 设置过期时间
      timestamp,
    };
    Cookies.set(key, item, {
      domain: shopifyDomain,
      expires: 30,
    });
  },
  // 获取cookie
  getItemWithExpiry(key) {
    const itemString = Cookies.get(key);
    if (!itemString) {
      return null;
    }
    const item = JSON.parse(itemString);
    const now = new Date();

    // 检查是否过期
    if (now.getTime() > item.expiry) {
      Cookies.remove(key, {
        domain: shopifyDomain,
        expires: 30,
      });
      return null;
    }
    return item;
  },
  // 初始化
  init() {
    // start_ai_generated
    // 存在用户直接刷新页面的情况，重定向到passport，带上登录态
    const passportThemeLoginUrl = Cookies.get("passport-theme-url");
    if (passportThemeLoginUrl) {
      Cookies.remove("passport-theme-url", {
        domain: shopifyDomain,
        expires: 30,
      });
      window.location.href = passportThemeLoginUrl;
    }
    // end_ai_generated
    this.fbClientId = $(".registrations-third-login").data(
      "facebook-client-id"
    );
    this.facebookLogin = new FacebookLogin(this.fbClientId);
    /** registrations-main event */
    this.registrationsMainEvent();
    /** registrations-subscribe-sms event */
    this.registrationsSubscribeSMSEvent();
    /** registrations-quick-login event */
    this.registrationsQuickLoginEvent();
    /** registrations-password-login event */
    // start_ai_generated
    // 注册密码登录事件
    // end_ai_generated
    this.registrationsPasswordLoginEvent();
    // start_ai_generated
    // 注册第三方登录事件
    // end_ai_generated
    this.registrationsThirdLoginEvent();
    // start_ai_generated
    // 注册优惠券事件
    // end_ai_generated
    this.registrationsCouponsEvent();
    // start_ai_generated
    // 注册提醒事件
    // end_ai_generated
    this.registrationsReminderEvent();
    // start_ai_generated
    // 初始化注册跟踪实例
    // end_ai_generated
    this.registrationsTrackIns = new RegistrationsTrack();
    // 设置是否弹窗标识
    this.setFlowUpTag();
  },
  fetchSendValidationEmail({ email, app }) {
    const applicationToken = Cookies.get(`${app}-token`);
    return new Promise((resolve, reject) => {
      if (!window.grecaptcha) return;
      grecaptcha.ready(() => {
        grecaptcha
          .execute(ShopMetafields.recaptcha, { action: "verifyAccount" })
          .then((xrecaptchaKey) => {
            $.ajax({
              headers: {
                "X-Recaptcha-Token": xrecaptchaKey,
                "X-Application-Token": applicationToken,
              },
              type: "POST",
              url: "/apps/pp/identity/users/send_validation_email",
              dataType: "json",
              data: JSON.stringify({ email, app }),
              success: function success(res) {
                if (res.status > 100 && res.status < 300) {
                  resolve();
                } else {
                  reject();
                }
              },
              error: (err) => {
                reject();
              },
            });
          });
      });
    });
  },
  registrationsMainEvent() {
    const _this = this;
    $(".registrations-main .js-verify-account-error a").on(
      "click",
      function (e) {
        e.preventDefault();
        if (!window.grecaptcha) return;
        const $el = $(this).parents(".rsm-form");
        const formValues = $el.serializeArray();
        const emailName = "registrations[email]";
        const email = formValues.filter((v) => v.name === emailName)?.[0].value;
        _this.fetchSendValidationEmail({ email, app }).then(() => {
          $(".registrations-main").addClass("hidden");
          $(".registrations-activate").removeClass("hidden");
          $(".registrations-activate .registrations-activate-wrap").attr(
            "data-return-back-type",
            "main"
          );
          $(".rss-desc-email").text(email);
          $(".js-verify-account-error").addClass("hidden");
        });
      }
    );
    $(".registrations-activate .js-rss-again a").on("click", function (e) {
      e.preventDefault();
      if (!window.grecaptcha) return;
      const email = $(".rss-desc-email").text();
      // start_ai_generated
      // $(this).addClass("hidden");
      // $(".js-again-loading").removeClass("hidden");
      // end_ai_generated
      const $rsrTip = $(".registrations-activate .js-rsr-tip");
      const send_tip = $rsrTip.data("send-tip");
      const lock_tip = $rsrTip.data("lock-tip");
      const $infoIcon = $rsrTip.find(".js-tip-info-icon");
      const $errorIcon = $rsrTip.find(".js-tip-error-icon");
      const $tipText = $rsrTip.find(".js-tip-text");
      $(this).css("pointer-events", "none");
      _this
        .fetchSendValidationEmail({ email, app })
        .then(() => {
          const that = this;
          const $footer = $(".registrations-activate-footer");
          let countDownTime = Number($footer.data("count-down-time"));
          const retrieveText = $footer.data("retrieve-text");
          const secondsText = $footer.data("seconds-text");
          const sendAgainText = $footer.data("send-again-text");
          // $(this).removeClass("hidden");
          $rsrTip.removeClass("hidden");
          $infoIcon.removeClass("hidden");
          $tipText.text(send_tip);
          let countDownTimer = setInterval(() => {
            countDownTime--;
            $(that).html(
              `${retrieveText}&nbsp;${countDownTime}&nbsp;${secondsText}`
            );
            if (countDownTime <= 0) {
              $(that).html(`&nbsp;${sendAgainText}`);
              $(that).css("pointer-events", "all");
              clearInterval(countDownTimer);
            }
          }, 1000);
          let timer = setTimeout(() => {
            $rsrTip.addClass("hidden");
            $infoIcon.addClass("hidden");
            $tipText.text("");
            clearTimeout(timer);
          }, 5000);
        })
        .catch((err) => {
          console.log(err, "err");
          $(this).css("pointer-events", "all");
          if (err) {
            $rsrTip.removeClass("hidden");
            $errorIcon.removeClass("hidden");
            $tipText.text(lock_tip);
            let timer = setTimeout(() => {
              $rsrTip.addClass("hidden");
              $errorIcon.addClass("hidden");
              $tipText.text("");
              clearTimeout(timer);
            }, 5000);
          }
        })
        .finally(() => {
          $(_this).removeClass("hidden");
          // $(".js-again-loading").addClass("hidden");
        });
    });
    $(".registrations-activate .js-activate-btn-return").on(
      "click",
      function (e) {
        e.preventDefault();
        const returnBackType = $(
          ".registrations-activate .registrations-activate-wrap"
        ).data("return-back-type");
        // start_ai_generated
        returnBackType === "password"
          ? $(".registrations-password-login").removeClass("hidden")
          : $(".registrations-main").removeClass("hidden");
        $(".registrations-activate").addClass("hidden");
        // end_ai_generated
      }
    );
    $(".registrations-activate .js-activate-btn-get").on("click", function (e) {
      // start_ai_generated
      $(".registrations-model").addClass("hidden");
      $(".registrations-activate").addClass("hidden");
      // end_ai_generated
    });
  },
  registrationsSubscribeSMSEvent() {
    const _this = this;
    $('.registrations-subscribe-sms button[type="submit"]').on(
      "click",
      function (e) {
        e.stopPropagation();
        e.preventDefault();
        const dealsTypeMob = $(
          ".registrations-subscribe-sms .registrations-subscribe-sms-body"
        ).data("deals-type-mob");
        const dealsTypePc = $(
          ".registrations-subscribe-sms .registrations-subscribe-sms-body"
        ).data("deals-type-pc");
        // start_ai_generated
        const genre = window.innerWidth < 768 ? dealsTypeMob : dealsTypePc;
        // end_ai_generated
        const $el = $(this).parents(".rssms-form");
        const formValues = $el.serializeArray();
        const phoneName = "subscribeSMS[phone_number]";
        const email = $(".registrations-subscribe-sms").data("register-email");
        const phone_number = formValues.filter((v) => v.name === phoneName)?.[0]
          .value;
        const $interfaceErrorEl = $(
          ".registrations-subscribe-sms .js-phone-interface-error"
        );
        let html = "";
        const countDownTime = $interfaceErrorEl.data("count-down-time");
        const interfaceError = $interfaceErrorEl.data("interface-error");
        const seconds = $interfaceErrorEl.data("sms-seconds");
        const $phoneNumberEl = $(
          ".registrations-subscribe-sms .js-phone-normal-error"
        );
        const phoneFormatError = $phoneNumberEl.data("phone-format-error");
        const phoneEmptyError = $phoneNumberEl.data("phone-empty-error");
        if (!phone_number) {
          $phoneNumberEl.text(phoneEmptyError);
          $(".js-phone-input").addClass("input-error");
          return;
        }
        // if (!regex.test(phone_number)) {
        //   $phoneNumberEl.text(phoneFormatError);
        //   $(".js-phone-input").addClass("input-error");
        //   return;
        // }
        const params = {
          phone_number,
          email,
          shopify_domain: Shopify.shop,
          genre,
          single_brand_subscribe: true,
          register_source: window.location.href,
        };
        _this.handleLoadingStatus($el, "loading");
        Shopify.contentCreator.pastApi.subscribe_activities_emails({
          params,
          fn: (res) => {
            _this.handleLoadingStatus($el, "unloading");
            $(".registrations-subscribe-sms").addClass("hidden");
            $(".registrations-coupons").removeClass("hidden");
          },
          error: (err) => {
            if (err?.status === 400) {
              $phoneNumberEl.text(phoneFormatError);
              $(".js-phone-input").addClass("input-error");
              _this.handleLoadingStatus($el, "unloading");
              return;
            }
            html += `${interfaceError}&nbsp;<span>${countDownTime}</span>&nbsp;${seconds}`;
            $interfaceErrorEl.html(html);
            $interfaceErrorEl.removeClass("hidden");
            $interfaceErrorEl.find("span").addClass("js-count-down-time");
            let countDownTimeCount = Number(countDownTime);
            let timer = setInterval(() => {
              countDownTimeCount--;
              $interfaceErrorEl.find("span").text(countDownTimeCount);
              if (countDownTimeCount <= 0) {
                clearInterval(timer);
                $interfaceErrorEl.addClass("hidden");
                $(".registrations-subscribe-sms").addClass("hidden");
                $(".registrations-coupons").removeClass("hidden");
              }
            }, 1000);
            _this.handleLoadingStatus($el, "unloading");
            console.log(err, "err");
          },
        });
      }
    );
    $(".registrations-subscribe-sms .js-skip-sms-btn").on(
      "click",
      function (e) {
        $(".registrations-subscribe-sms").addClass("hidden");
        $(".registrations-coupons").removeClass("hidden");
      }
    );
    $(".registrations-subscribe-sms .js-phone-input").on("focus", function () {
      const phoneNumberError = $(".js-phone-normal-error").text();
      if (phoneNumberError) {
        phoneNumberError && $(".js-phone-normal-error").text("");
        $(this).removeClass("input-error");
      }
    });
  },
  registrationsQuickLoginEvent() {
    const _this = this;
    $('.registrations-quick-login button[type="submit"]').on(
      "click",
      function (e) {
        e.stopPropagation();
        e.preventDefault();
        const $el = $(this).parents(".rsql-form");
        const formValues = $el.serializeArray();

        const emailName = "quickLogin[email]";
        const email = formValues.filter((v) => v.name === emailName)?.[0].value;
        const $emailErrorEl = $el.find(".js-email-error");
        const $emailInputEl = $el.find(".js-rsql-input");
        let validator = new Validator();
        validator.add(
          email,
          "isNonEmpty",
          emailName,
          $emailErrorEl.data("email-required-error")
        );
        validator.add(
          email,
          "isEmail",
          emailName,
          $emailErrorEl.data("is-email-error")
        );
        let errorMsgObj = validator.validate();

        for (const msgObj in errorMsgObj) {
          if (Object.hasOwnProperty.call(errorMsgObj, msgObj)) {
            const msgs = errorMsgObj[msgObj];
            if (msgs && msgs.length) {
              switch (msgObj) {
                case emailName:
                  $emailErrorEl.text(msgs[0]);
                  $emailInputEl.addClass("input-error");
                  break;
                default:
                  break;
              }
              break;
            }
          }
        }

        if (!Reflect.ownKeys(errorMsgObj).length) {
          if (!window.grecaptcha) return;
          _this.handleLoadingStatus($el, "loading");
          grecaptcha.ready(() => {
            grecaptcha
              .execute(ShopMetafields.recaptcha, { action: "login" })
              .then((recaptchaKey) => {
                $.ajax({
                  headers: { "X-Recaptcha-Token": recaptchaKey },
                  type: "POST",
                  url: "/apps/pp/identity/quick_logins/login_token",
                  dataType: "json",
                  data: JSON.stringify({
                    email,
                    sign: "email",
                    app: `${app}`,
                    data: btoa(
                      JSON.stringify({
                        redirect:
                          location.href +
                          (location.search ? location.search + "&" : "?") +
                          "ref=quickloginauth_reg_sub_pop",
                      })
                    ),
                  }),
                  success: function success(res) {
                    if (res.status > 100 && res.status < 300) {
                      $(".registrations-reminder").removeClass("hidden");
                      $(".registrations-quick-login").addClass("hidden");
                      $(".registrations-reminder .rsr-desc-email").text(email);
                      _this.registrationsTrackIns.loginTrack({
                        position: "login_quick_login",
                      });
                    }
                    console.log("quickres:---------", res);
                    _this.handleLoadingStatus($el, "unloading");
                  },
                  error: (err) => {
                    let errorJSON = err.responseJSON;
                    console.log(err, "errr-");
                    if (err.status === 422) {
                      if (errorJSON.error_code === "106") {
                        // 邮箱不存在
                        const no_registered_error = $emailErrorEl.data(
                          "email-no-registered-error"
                        );
                        $emailErrorEl.html(no_registered_error);
                        $emailInputEl.addClass("input-error");
                        $(".rsql-form .js-email-error a").on(
                          "click",
                          function (e) {
                            e.preventDefault();
                            $(".registrations-main").removeClass("hidden");
                            $(".registrations-quick-login").addClass("hidden");
                            $emailErrorEl.text("");
                            $emailInputEl.val("").removeClass("input-error");
                          }
                        );
                      }
                      if (errorJSON.error_code === "105") {
                        //
                      }
                    }
                    _this.handleLoadingStatus($el, "unloading");
                  },
                });
              });
          });
        }
      }
    );
    $(".registrations-quick-login .rsql-login-text").on("click", function (e) {
      e.preventDefault();
      const email = $(".registrations-quick-login .js-rsql-input").val();
      $(".registrations-password-login").removeClass("hidden");
      $(".registrations-password-login .js-email-input").val(email);
      $(".registrations-quick-login").addClass("hidden");
    });
    $(".registrations-quick-login .rsql-back").on("click", function (e) {
      $(".registrations-main").removeClass("hidden");
      $(".registrations-quick-login").addClass("hidden");
      _this.registrationsTrackIns.closeTrack({
        position: "",
        page_group: "login_pop",
        button_name: "back",
      });
    });
    $(".registrations-quick-login .js-rsql-input").on("focus", function () {
      const $emailErrorEl = $(".registrations-quick-login .js-email-error");
      const emailError = $emailErrorEl.text();
      if (emailError) {
        emailError && $emailErrorEl.text("");
        $(this).removeClass("input-error");
      }
    });
  },
  registrationsPasswordLoginEvent() {
    const _this = this;
    $(".registrations-password-login .rspl-back").on("click", function (e) {
      _this.registrationsTrackIns.backRegistrationsTrack({
        buttonName: "back",
      });
      $(".registrations-quick-login").removeClass("hidden");
      $(".registrations-password-login").addClass("hidden");
    });
    $(".registrations-password-login .rspl-forget").on("click", function (e) {
      const passportUrl = _this.getPassportUrl();
      const $emailEl = $(".registrations-password-login .rspl-input-email");
      const email = $emailEl.val();
      let b_email = "";
      if (email) {
        b_email = btoa($emailEl.val());
      }
      window.location.href = `${passportUrl}/forgot?app=${app}&redirect=${
        location.href
      }${b_email && `&ee=${b_email}`}&ref=quickloginauth`;
    });

    $('.registrations-password-login button[type="submit"]').on(
      "click",
      function (e) {
        e.stopPropagation();
        e.preventDefault();
        const $el = $(this).parents(".rspl-form");
        const formValues = $el.serializeArray();
        console.log(formValues);

        const emailName = "passwordLogin[email]";
        const passwordName = "passwordLogin[password]";
        const email = formValues.filter((v) => v.name === emailName)?.[0].value;
        const password = formValues.filter((v) => v.name === passwordName)?.[0]
          .value;
        const $emailErrorEl = $el.find(".js-email-error");
        const $emailInputEl = $el.find(".js-email-input");
        const $passwordErrorEl = $el.find(".js-password-error");
        const $passwordInputEl = $el.find(".rspl-form-item-pwd");
        let validator = new Validator();
        validator.add(
          email,
          "isNonEmpty",
          emailName,
          $emailErrorEl.data("email-required-error")
        );
        validator.add(
          email,
          "isEmail",
          emailName,
          $emailErrorEl.data("is-email-error")
        );
        validator.add(
          password,
          "isNonEmpty",
          passwordName,
          $passwordErrorEl.data("password-required-error")
        );
        validator.add(
          password,
          "minLength:8",
          passwordName,
          $passwordErrorEl.data("password-length-error")
        );
        validator.add(
          password,
          "maxLength:20",
          passwordName,
          $passwordErrorEl.data("password-length-error")
        );
        let errorMsgObj = validator.validate();

        for (const msgObj in errorMsgObj) {
          if (Object.hasOwnProperty.call(errorMsgObj, msgObj)) {
            const msgs = errorMsgObj[msgObj];
            if (msgs && msgs.length) {
              switch (msgObj) {
                case emailName:
                  $emailErrorEl.text(msgs[0]);
                  $emailInputEl.addClass("input-error");
                  break;
                case passwordName:
                  $passwordErrorEl.text(msgs[0]);
                  $passwordInputEl.addClass("input-error");
                  break;
                default:
                  break;
              }
              break;
            }
          }
        }
        if (!Reflect.ownKeys(errorMsgObj).length) {
          _this.handleLoadingStatus($el, "loading");
          if (!window.grecaptcha) return;
          grecaptcha.ready(() => {
            grecaptcha
              .execute(ShopMetafields.recaptcha, { action: "login" })
              .then((recaptchaKey) => {
                $.ajax({
                  type: "POST",
                  headers: { "X-Recaptcha-Token": recaptchaKey },
                  url: "/apps/pp/api/password-signin",
                  dataType: "json",
                  data: JSON.stringify({
                    email,
                    password,
                    app,
                  }),
                  success: function success(res) {
                    if (res.status > 100 && res.status < 300) {
                      const { auth_token, user_id } = res.data;
                      const b_auth_token = btoa(auth_token);
                      Cookies.set(`${app}-token`, auth_token, {
                        domain: shopifyDomain,
                        expires: 30,
                      });
                      Cookies.set(`${app}-euid`, user_id, {
                        domain: shopifyDomain,
                        expires: 30,
                      });
                      const passportThemeLoginUrl = `${_this.getPassportUrl()}/theme-login?app=${app}&t=${b_auth_token}&redirect=${
                        location.href
                      }`;
                      // 重定向到passport,带上登录态
                      window.location.href = passportThemeLoginUrl;
                      // token存到localStorage
                      localStorage.setItem("b_auth_token", b_auth_token);
                      Cookies.set("passport-theme-url", passportThemeLoginUrl, {
                        domain: shopifyDomain,
                        expires: 30,
                      });
                      $(".registrations-model").addClass("hidden");
                      // start_ai_generated
                      $(".registrations-password-login").addClass("hidden");
                      // end_ai_generated

                      _this.registrationsTrackIns.loginTrack({
                        position: "login_with_password",
                      });
                    } else if (res?.error_code === "105") {
                      const { validate_token } = res;
                      Cookies.set(`${app}-token`, validate_token, {
                        domain: shopifyDomain,
                        expires: 30,
                      });
                      Cookies.set(`${app}-info`, validate_token, {
                        domain: shopifyDomain,
                        expires: 30,
                      });
                      const $formNetworkError = $el.find(".js-network-error");
                      const verifyErrorPasswordText = $formNetworkError.data(
                        "verify-error-password"
                      );
                      $formNetworkError.removeClass("hidden");
                      $formNetworkError.html(verifyErrorPasswordText);
                      $(".registrations-password-login .js-network-error a").on(
                        "click",
                        function (e) {
                          console.log("e,", e);
                          e.preventDefault();
                          const $el = $(this).parents(".rspl-form");
                          const formValues = $el.serializeArray();
                          const emailName = "passwordLogin[email]";
                          const email = formValues.filter(
                            (v) => v.name === emailName
                          )?.[0].value;
                          _this
                            .fetchSendValidationEmail({ email, app })
                            .then(() => {
                              $(".registrations-activate").removeClass(
                                "hidden"
                              );
                              $(".registrations-password-login").addClass(
                                "hidden"
                              );
                              $(".rss-desc-email").text(email);
                              $(
                                ".registrations-activate .registrations-activate-wrap"
                              ).attr("data-return-back-type", "password");
                            });
                        }
                      );
                    }
                    console.log("passwordres:---------", res);
                    _this.handleLoadingStatus($el, "unloading");
                  },
                  error: (err) => {
                    if (err.status === 422 || err.status === 401) {
                      const $formNetworkError = $el.find(".js-network-error");
                      const infoErrorPasswordText =
                        $formNetworkError.data("network-error");
                      $formNetworkError.removeClass("hidden");
                      $formNetworkError.text(infoErrorPasswordText);
                    }
                    _this.handleLoadingStatus($el, "unloading");
                  },
                });
              });
          });
        }
      }
    );
    $(".registrations-password-login .rspl-input-email").on(
      "focus",
      function () {
        const $emailErrorEl = $(
          ".registrations-password-login .js-email-error"
        );
        const $networkEl = $(".registrations-password-login .js-network-error");
        const emailError = $emailErrorEl.text();
        const networkError = $networkEl.text();
        if (emailError) {
          emailError && $emailErrorEl.text("");
          $(this).removeClass("input-error");
        }
        if (networkError) {
          networkError && $networkEl.text("");
          $networkEl.addClass("hidden");
        }
      }
    );
    $(".registrations-password-login .js-password-input").on(
      "focus",
      function () {
        const $passwordErrorEl = $(
          ".registrations-password-login .js-password-error"
        );
        const $networkEl = $(".registrations-password-login .js-network-error");
        const passwordError = $passwordErrorEl.text();
        const networkError = $networkEl.text();
        if (passwordError) {
          passwordError && $passwordErrorEl.text("");
          $(".registrations-password-login .rspl-form-item-pwd").removeClass(
            "input-error"
          );
        }
        if (networkError) {
          networkError && $networkEl.text("");
          $networkEl.addClass("hidden");
        }
      }
    );
  },
  registrationsThirdLoginEvent() {
    const _this = this;
    $(".registrations-third-login .js-third-google").on("click", function (e) {
      e.preventDefault();
      console.log("google");
      const googleAuthHref = _this.getGoogleAuthURL({
        location: window.location,
      });
      console.log(googleAuthHref, "googleAuthHref");
      if (googleAuthHref) {
        _this.registrationsTrackIns.loginWithThirdTrack({ typeText: "google" });
      }
      window.location.href = googleAuthHref;
    });
    $(".registrations-third-login .js-third-facebook").on(
      "click",
      function (e) {
        e.preventDefault();
        const passportUrl = _this.getPassportUrl();
        const fb_redirect_uri = `${passportUrl}/auth/facebook/callback`;
        function getParamsFromObject(params) {
          return (
            "?" +
            Object.keys(params)
              .map((param) => `${param}=${encodeURIComponent(params[param])}`)
              .join("&")
          );
        }

        const scope = "public_profile,email";
        const return_scopes = false;
        const response_type = "token";

        const params = {
          client_id: _this.fbClientId,
          redirect_uri: fb_redirect_uri,
          state: encodeURIComponent(
            JSON.stringify({
              loginType: "facebook",
              app,
              redirect: location.href,
              callback: fb_redirect_uri,
            })
          ),
          return_scopes,
          scope,
          response_type,
          auth_type: "",
        };
        if (_this.facebookLogin.getIsMobile()) {
          window.location.href = `https://www.facebook.com/v3.1/dialog/oauth${getParamsFromObject(
            params
          )}`;
          _this.registrationsTrackIns.loginWithThirdTrack({
            typeText: "facebook",
          });
        } else {
          if (!window.FB) return;
          window.FB.login(
            (loginResponse) =>
              _this.facebookLogin.statusChangeCallback(
                loginResponse,
                ({ accessToken }) => {
                  if (accessToken) {
                    window.location.href = `${fb_redirect_uri}#access_token=${accessToken}&state=${params.state}`;
                    _this.registrationsTrackIns.loginWithThirdTrack({
                      typeText: "facebook",
                    });
                  }
                }
              ),
            params
          );
        }
      }
    );
  },
  registrationsCouponsEvent() {
    const _this = this;
    $(".registrations-coupons .rsc-get-btn").on("click", function (e) {
      _this.registrationsTrackIns = new RegistrationsTrack();
      _this.registrationsTrackIns.useCodeTrack();
      e.preventDefault();
      $(".registrations-model").addClass("hidden");
      // start_ai_generated
      $(".registrations-coupons").addClass("hidden");
      // end_ai_generated
      const b_auth_token = localStorage.getItem("b_auth_token");
      window.location.href = `${_this.getPassportUrl()}/theme-login?app=${app}&t=${b_auth_token}&redirect=${
        location.href
      }`;
      // start_ai_generated
      // 点击领取优惠券后，清除localStorage
      // end_ai_generated
      const passportThemeLoginUrl = Cookies.get("passport-theme-url");
      passportThemeLoginUrl &&
        Cookies.remove("passport-theme-url", {
          domain: shopifyDomain,
          expires: 30,
        });
    });
    $(".registrations-coupons .rsc-coupons-desc a").on("click", function (e) {
      const $el = $(".registrations-main .rsm-form");
      const $rsrTip = $(".registrations-coupons .js-rsr-tip");
      const send_tip = $rsrTip.data("send-tip");
      const lock_tip = $rsrTip.data("lock-tip");
      const $infoIcon = $rsrTip.find(".js-tip-info-icon");
      const $errorIcon = $rsrTip.find(".js-tip-error-icon");
      const $tipText = $rsrTip.find(".js-tip-text");
      const $couponsEl = $(".registrations-coupons");
      const formValues = $el.serializeArray();
      const emailName = "registrations[email]";
      const email = formValues.filter((v) => v.name === emailName)?.[0].value;
      $(this).css("pointer-events", "none");
      _this
        .fetchSendValidationEmail({ email, app })
        .then(() => {
          const that = this;
          const $footerDesc = $couponsEl.find(
            ".rsc-footer-wrap .rsc-coupons-desc"
          );
          let countDownTime = Number($footerDesc.data("count-down-time"));
          const retrieveText = $footerDesc.data("retrieve-text");
          const secondsText = $footerDesc.data("seconds-text");
          const sendAgainText = $footerDesc.data("send-again-text");
          let timer = setInterval(() => {
            countDownTime--;
            $(that).html(
              `<span>${retrieveText}</span>&nbsp;<span>${countDownTime}</span>&nbsp;<span>${secondsText}</span>`
            );
            if (countDownTime <= 0) {
              $(that).html(`&nbsp;${sendAgainText}`);
              $(that).css("pointer-events", "all");
              clearInterval(timer);
            }
          }, 1000);
          $rsrTip.removeClass("hidden");
          $infoIcon.removeClass("hidden");
          $tipText.text(send_tip);
          let tipsTimer = setTimeout(() => {
            $rsrTip.addClass("hidden");
            $infoIcon.addClass("hidden");
            $tipText.text("");
            clearTimeout(tipsTimer);
          }, 5000);
        })
        .catch((err) => {
          $(this).css("pointer-events", "all");
          if (err) {
            $rsrTip.removeClass("hidden");
            $errorIcon.removeClass("hidden");
            $tipText.text(lock_tip);
            let timer = setTimeout(() => {
              $rsrTip.addClass("hidden");
              $errorIcon.addClass("hidden");
              $tipText.text("");
              clearTimeout(timer);
            }, 5000);
          }
        });
    });
  },
  registrationsReminderEvent() {
    $(".registrations-reminder .rsr-again-text a").on("click", function (e) {
      e.preventDefault();
      const _this = this;
      const email = $(".registrations-reminder .rsr-desc-email").text();
      if (!window.grecaptcha) return;
      const $rsrTip = $(".registrations-reminder .js-rsr-tip");
      const send_tip = $rsrTip.data("send-tip");
      const lock_tip = $rsrTip.data("lock-tip");
      const $infoIcon = $rsrTip.find(".js-tip-info-icon");
      const $errorIcon = $rsrTip.find(".js-tip-error-icon");
      const $tipText = $rsrTip.find(".js-tip-text");
      // start_ai_generated
      $(this).addClass("hidden");
      $(".js-again-loading").removeClass("hidden");
      // end_ai_generated
      grecaptcha.ready(() => {
        grecaptcha
          .execute(ShopMetafields.recaptcha, { action: "login" })
          .then((recaptchaKey) => {
            $.ajax({
              type: "POST",
              url: "/apps/pp/identity/quick_logins/login_token",
              headers: { "X-Recaptcha-Token": recaptchaKey },
              dataType: "json",
              data: JSON.stringify({
                email,
                sign: "email",
                app,
                data: JSON.stringify({
                  redirect: location.href,
                }),
              }),
              success: function success(res) {
                $(_this).removeClass("hidden");
                $(".js-again-loading").addClass("hidden");
                console.log("resend_login_token res:---------", res);
                if (res.status > 100 && res.status < 300) {
                  $rsrTip.removeClass("hidden");
                  $infoIcon.removeClass("hidden");
                  $tipText.text(send_tip);
                  let timer = setTimeout(() => {
                    $rsrTip.addClass("hidden");
                    $infoIcon.addClass("hidden");
                    $tipText.text("");
                    clearTimeout(timer);
                  }, 5000);
                }
              },
              error: (err) => {
                $(_this).removeClass("hidden");
                $(".js-again-loading").addClass("hidden");
                console.log(err, "errr-");
                if (err) {
                  $rsrTip.removeClass("hidden");
                  $errorIcon.removeClass("hidden");
                  $tipText.text(lock_tip);
                  let timer = setTimeout(() => {
                    $rsrTip.addClass("hidden");
                    $errorIcon.addClass("hidden");
                    $tipText.text("");
                    clearTimeout(timer);
                  }, 5000);
                }
              },
            });
          });
      });
    });
    $(".registrations-reminder .rsr-btn-again").on("click", function () {
      $(".registrations-reminder").addClass("hidden");
      $(".registrations-quick-login").removeClass("hidden");
    });
    $(".registrations-reminder .rsr-btn-get").on("click", function () {
      $(".registrations-model").addClass("hidden");
      // start_ai_generated
      $(".registrations-main").removeClass("hidden");
      $(".registrations-reminder").addClass("hidden");
      // end_ai_generated
    });
  },
};

// 策略
class Strategy {
  isNonEmpty(value, name, errorMsg) {
    if (!value.length)
      return {
        [name]: errorMsg,
      };
  }
  isChecked(value, name, errorMsg) {
    if (value !== "on")
      return {
        [name]: errorMsg,
      };
  }
  isEmail(value, name, errorMsg) {
    if (
      !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        value
      )
    )
      return {
        [name]: errorMsg,
      };
  }
  // 最小长度限制
  minLength(value, length, name, errorMsg) {
    if (value?.length > 0 && value?.length < length) {
      return {
        [name]: errorMsg,
      };
    }
  }
  // 最大长度限制
  maxLength(value, length, name, errorMsg) {
    if (value?.length > length) {
      return {
        [name]: errorMsg,
      };
    }
  }
}

// 表单验证环境类
class Validator {
  constructor() {
    this.cache = [];
    this.strategies = new Strategy();
  }
  add(value, rule, name, errorMsg) {
    const param = rule.split(":");
    this.cache.push(() => {
      const strategy = param.shift();
      param.unshift(value);
      param.push(name);
      param.push(errorMsg);
      return this.strategies[strategy].apply(value, param);
    });
  }
  validate() {
    let errorMsgs = [];
    for (let validatorFunc of this.cache) {
      let msg = validatorFunc();
      if (msg) errorMsgs.push(msg);
    }
    return errorMsgs.reduce((acc, obj) => {
      let key = Object.keys(obj)[0];
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj[key]);
      return acc;
    }, {});
  }
}

RegistrationsModal.init();
